import { render, staticRenderFns } from "./Draft.vue?vue&type=template&id=133e4e65&scoped=true&"
import script from "./Draft.vue?vue&type=script&lang=js&"
export * from "./Draft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e4e65",
  null
  
)

export default component.exports